import React, { useState, useEffect } from 'react';
import { FaEdit, FaSave } from 'react-icons/fa';
import modalStyles from './Modal.module.css';
import PasswordModal from './PasswordModal';
const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const AccountModal = ({ closeModal }) => {
  const [userType, setUserType] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [studentId, setStudentId] = useState('');
  const [groupName, setGroupName] = useState('');
  const [teacherName, setTeacherName] = useState('');
  const [region, setRegion] = useState('');
  const [editedRegion, setEditedRegion] = useState('');
  const [isEditingRegion, setIsEditingRegion] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [ageRange, setAgeRange] = useState('');
  const [editedAgeRange, setEditedAgeRange] = useState('');
  const [isEditingAgeRange, setIsEditingAgeRange] = useState(false);


  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await fetch(`${API_URL}/user/profile`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });
        const data = await response.json();
        setUserType(data.user_type);
        setName(data.name);
        setRegion(data.region || '');
        setEditedRegion(data.region || '');
        setAgeRange(data.age_range || '');
        setEditedAgeRange(data.age_range || '');


        if (data.user_type === 'student') {
          setStudentId(data.student_id);
          setGroupName(data.group_name);
          setTeacherName(data.teacher_name);
        } else {
          setEmail(data.email);
          setAgeRange(data.age_range || '');
          setEditedAgeRange(data.age_range || '');
        }
      } catch (error) {
        setFeedbackMessage('Error fetching user profile');
        console.error('Error fetching user profile:', error);
      }
    };

    fetchUserProfile();
  }, []);

  const handleRegionEdit = () => {
    setIsEditingRegion(true);
  };

  const handleSaveRegion = async () => {
    try {
      const response = await fetch(`${API_URL}/user/update-region`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ region: editedRegion }),
      });
      const result = await response.json();
      if (response.ok) {
        setRegion(editedRegion);
        setIsEditingRegion(false);
        setFeedbackMessage('Region updated successfully.');
      } else {
        setFeedbackMessage(result.detail || 'Failed to update region.');
      }
    } catch (error) {
      setFeedbackMessage('Error updating region.');
      console.error('Region update error:', error);
    }
  };

  const handleSaveAgeRange = async () => {
    try {
      const response = await fetch(`${API_URL}/user/update-age`, {
        method: 'POST', // or 'PUT' based on your backend
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ age_range: editedAgeRange }),
      });
      const result = await response.json();
      if (response.ok) {
        setAgeRange(editedAgeRange);
        setIsEditingAgeRange(false);
        setFeedbackMessage('Age range updated successfully.');
      } else {
        setFeedbackMessage(result.detail || 'Failed to update age range.');
      }
    } catch (error) {
      setFeedbackMessage('Error updating age range.');
      console.error('Age range update error:', error);
    }
  };
  
  

  const handlePasswordChange = () => {
    setShowPasswordModal(true);
  };

  return (
    <div className={modalStyles.modal}>
      <div className={modalStyles.modalContent}>
        <span className={modalStyles.closeButton} onClick={closeModal}>&times;</span>
        <h2 className={modalStyles.title}>Account Details</h2>

        <div className={modalStyles.fieldContainer}>
          <label>Name: </label>
          <span className={modalStyles.fieldValue}>{name}</span>
        </div>

        {userType === 'student' ? (
          <>
            <div className={modalStyles.fieldContainer}>
              <label>Group Name: </label>
              <span className={modalStyles.fieldValue}>{groupName}</span>
            </div>
            <div className={modalStyles.fieldContainer}>
              <label>Teacher Name: </label>
              <span className={modalStyles.fieldValue}>{teacherName}</span>
            </div>
          </>
        ) : (
          <div className={modalStyles.fieldContainer}>
            <label>Email: </label>
            <span className={modalStyles.fieldValue}>{email}</span>
          </div>
        )}

        <div className={modalStyles.fieldContainer}>
          <label>Region: </label>
          {isEditingRegion ? (
            <>
              <input
                type="text"
                value={editedRegion}
                onChange={(e) => setEditedRegion(e.target.value)}
                className={modalStyles.inputField}
              />
              <FaSave
                className={modalStyles.editIcon}
                onClick={handleSaveRegion}
                title="Save"
              />
            </>
          ) : (
            <>
              <span className={modalStyles.fieldValue}>{region}</span>
              {userType !== 'student' && (
                <FaEdit
                  className={modalStyles.editIcon}
                  onClick={handleRegionEdit}
                  title="Edit Region"
                />
              )}
            </>
          )}
        </div>

        <div className={modalStyles.fieldContainer}>
          <label>Age Range: </label>
          {isEditingAgeRange ? (
            <>
              <select
                value={editedAgeRange}
                onChange={(e) => setEditedAgeRange(e.target.value)}
                className={modalStyles.inputField}
              >
                <option value="" disabled>Select your age range</option>
                <option value="5-9">5 - 9</option>
                <option value="10-13">10 - 13</option>
                <option value="14-18">14 - 18</option>
                <option value="18+">18+</option>
                <option value="other">Other</option>
              </select>
              <FaSave
                className={modalStyles.editIcon}
                onClick={handleSaveAgeRange}
                title="Save Age Range"
              />
            </>
          ) : (
            <>
              <span className={modalStyles.fieldValue}>{ageRange}</span>
              <FaEdit
                className={modalStyles.editIcon}
                onClick={() => setIsEditingAgeRange(true)}
                title="Edit Age Range"
              />
            </>
          )}
        </div>

      {userType !== 'student' && (
        <div className={modalStyles.fieldContainer}>
          <label>Password: </label>
          <span className={modalStyles.fieldValue}>********</span>
          <FaEdit
            className={modalStyles.editIcon}
            onClick={handlePasswordChange}
            title="Change Password"
          />
        </div>
      )}

        {userType !== 'student' && (
          <div className={modalStyles.fieldContainer}>
            <label>Password: </label>
            <span className={modalStyles.fieldValue}>********</span>
            <FaEdit
              className={modalStyles.editIcon}
              onClick={handlePasswordChange}
              title="Change Password"
            />
          </div>
        )}

        {feedbackMessage && (
          <p className={modalStyles.feedbackMessage}>{feedbackMessage}</p>
        )}
      </div>

      {showPasswordModal && <PasswordModal closeModal={() => setShowPasswordModal(false)} />}
    </div>
  );
};

export default AccountModal;

